module.exports = __webpack_public_path__ + "static/media/realtechfinalmockup7-18.9b78025e.webp";